// extracted by mini-css-extract-plugin
module.exports = {"root":"IconWrapper_root__1FPw1"};